import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { format } from "date-fns";
import { LandingClientService } from "src/app/common/services/landing-page.client";
import { StorageService } from "src/app/common/services/storage.service";
import { CensusDetails } from "src/app/common/interfaces/home/census.interface";
import { LandingPageService } from "../services/landing-page.service";
import {
  PanelData,
  SidePanelDetails,
} from "src/app/common/interfaces/home/side-panel-details.interface";
import { distinctUntilChanged, Subscription } from "rxjs";
import { AlertDetailsEnum } from "src/app/common/enums/Tasks.enum";
import { IAlertHeaderConfig, AlertHeaderConfig } from "src/app/common/interfaces/home/tasks.interface";
import { AppConstants } from "src/app/common/constants/app-constants";
import { ISODateFormat } from "src/app/common/constants/core-constants";

@Component({
  selector: "app-census",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./census.component.html",
  styleUrls: ["./census.component.scss"],
})
export class CensusComponent implements OnInit {
  displayedNumber: string = "";
  isTooltipVisible = false;
  details?: CensusDetails;
  displayValueLastTherapyDayUpComing = "0";
  openTEPanelDetails?: SidePanelDetails;
  lastTherapyDayPanelDetails?: SidePanelDetails;
  facilityId!: string | null;
  private facilitySubscription: Subscription | null = null;
  constructor(
    private landingClientService: LandingClientService,
    private storageService: StorageService,
    private landingpageService: LandingPageService,
  ) {}

  ngOnInit(): void {

    this.facilitySubscription =
      this.storageService.isSelectedFacility
      .pipe(
        distinctUntilChanged(),
      ).subscribe((facilityId) => {
        this.facilityId = facilityId;
        this.getCensusDetails();
      });
  }

  ngOnDestroy() {
    this.facilitySubscription?.unsubscribe();
  }

  updateDisplayedNumber(): void {
    if (
      this.details?.lastTherpayDateUpcomingCount &&
      this.details?.lastTherpayDateUpcomingCount > 9999
    ) {
      const firstTwoDigits = Math.floor(
        this.details?.lastTherpayDateUpcomingCount / 10
      )
        .toString()
        .slice(0, 2); // Get the first two digits
      this.displayValueLastTherapyDayUpComing = `${firstTwoDigits}..`;
    } else {
      this.displayValueLastTherapyDayUpComing =
        this.details && this.details.lastTherpayDateUpcomingCount
          ? this.details.lastTherpayDateUpcomingCount?.toString()
          : "0";
    }
  }

  showTooltip(): void {
    if (this.details && this.details.lastTherpayDateUpcomingCount > 99) {
      this.isTooltipVisible = true;
    }
  }

  hideTooltip(): void {
    this.isTooltipVisible = false;
  }

  getCensusDetails() {
    if (this.facilityId === null) {
      return;
    }
    this.landingClientService
      .getCensusDetails(this.facilityId)
      .subscribe((response: CensusDetails) => {
        this.details = response;
        this.updateDisplayedNumber();
      });
  }

  preparePanelDetailsForOpenTE() {
    if (this.openTEPanelDetails) {
      return this.openTEPanelDetails;
    }
    this.openTEPanelDetails = {
      title: "Residents with Therapy Episodes",
      panelDetails: [],
    };
    this.details?.openTEs.forEach((openTE) => {
      const panelData: PanelData = {
      patientName: openTE.patientName,
      discipline: openTE.discipline,
      date: format(new Date(openTE.soc), ISODateFormat),
      };
      this.openTEPanelDetails?.panelDetails.push(panelData);
    });
    return this.openTEPanelDetails;
  }

  preparePanelDetailsForLastTherapyDayUpcoming() {
    if (this.lastTherapyDayPanelDetails) {
      return this.lastTherapyDayPanelDetails;
    }
    this.lastTherapyDayPanelDetails = {
      title: "Last Therapy Day Upcoming",
      panelDetails: [],
    };
    this.details?.lastTherpayDateUpcomingDetails.forEach((details) => {
      const panelData: PanelData = {
        patientName: details.patientName,
        discipline:details.discipline,
        date:format(new Date(details.eoc), ISODateFormat),
        route: `/patient/${this.facilityId}/profile/${details.patientId}/forecast`,
      };
      this.lastTherapyDayPanelDetails?.panelDetails.push(panelData);
    });
    return this.lastTherapyDayPanelDetails;
  }

  openSidePanel(isOpenTE: boolean) {
    const data = isOpenTE
      ? this.preparePanelDetailsForOpenTE()
      : this.preparePanelDetailsForLastTherapyDayUpcoming();
    const headerSection: Partial<Record<AlertDetailsEnum, IAlertHeaderConfig>> = {
      [AlertDetailsEnum.Patient]: new AlertHeaderConfig(AppConstants.patient, false),
      [AlertDetailsEnum.Discipline]: new AlertHeaderConfig(AppConstants.discipline, false),
      [AlertDetailsEnum.Date]: new AlertHeaderConfig(AppConstants.SOCDate, false)
    };
    data.headerSection = headerSection;
    this.landingpageService.setSidePanelData(data);
    this.landingpageService.toggleSidePanel(true);
  }
}
